import { TTimeRangeOptionsItem } from '../types';

export const timeRangeOptions: TTimeRangeOptionsItem[] = [
  {
    textCn: '今天',
    text: 'Today',
    value: 'today',
    channels: ['youtube', 'tiktok'],
  },
  {
    textCn: '近7天',
    text: 'Last 7 Days',
    value: 'last_7_days',
    channels: ['tiktok'],
  },
  {
    textCn: '近30天',
    text: 'Last 30 Days',
    value: 'last_30_days',
    channels: ['tiktok'],
  },
];

export const defaultValueKeyList = ['last_7_days', 'last_30_days', 'today'];
